export default __webpack_public_path__ + "static/media/mongodb.3cc78486.png";